module.exports = __webpack_public_path__ + "img/Weapon_106.3109d864.png";